export const dateString = (date) =>
  new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(new Date(`${date}T00:00:00.000`))

export const dateTimeString = (date) =>
  new Intl.DateTimeFormat("en-US", {
    dateStyle: "full",
    timeStyle: "long",
    timeZone: process.env.GATSBY_DEFAULT_TIMEZONE,
  }).format(new Date(date))

const baseRules = (rules, objectMapping) =>
  rules.map((block) => {
    const newBlock = block
    newBlock.children = block.children.map((subBlock) => {
      const newSubBlock = subBlock
      newSubBlock.text = subBlock.text.replace(
        /\${([^}]+)}/g,
        (_, prop) => objectMapping[prop]
      )
      return newSubBlock
    })
    return newBlock
  })

export default baseRules
